import { render, staticRenderFns } from "./campaignMatcherPlate.vue?vue&type=template&id=ec04f8dc&"
import script from "./campaignMatcherPlate.vue?vue&type=script&lang=js&"
export * from "./campaignMatcherPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports